import React, { useEffect, useState } from 'react'
import {
    CCard,
    CCardHeader,
    CCardBody,
    CCardText,
    CTable,
    CTableBody,
    CTableRow,
    CTableDataCell,
    CRow,
    CCol,
    CFormSelect,
    CCardTitle,
} from '@coreui/react'

import CookieFunctions from '../../functions/CookieFunctions';
import { timeOffNames } from '../../Constants';
import globalFunctions from '../../functions/GlobalFunctions';

export default function AdminSummary({ driver }) {
    const [summary, setSummary] = useState(null)
    const [type, setType] = useState(Object.keys(timeOffNames[driver[0].driver_type][driver[0].country])[0])

    function getSummary() {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());
        
        const formData = new FormData();
        formData.append("timeOffType", type)
        formData.append("driverId", driver[0].mpp_id)
        formData.append("country", driver[0].country)
        formData.append("driverType", driver[0].driver_type)

        fetch("/api/admin/timeOffSummary",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            setSummary(data);
        })
    }

    useEffect(() => {
        getSummary(Object.keys(timeOffNames[driver[0].driver_type][driver[0].country])[0])
    }, [type, driver])

    return (
        <CCard style={{ marginBottom: '1rem' }}>
            <CCardHeader>Summary</CCardHeader>
            <CCardBody>
                <CRow>
                    <CCol sm="12" className='my-2'>
                        <CCardText className='fs-4'>Time Off Type</CCardText>
                    </CCol>
                    <CCol sm="4" className='my-2'>
                        <CFormSelect onChange={(e) => { setType(e.target.value) }}>
                            {Object.keys(timeOffNames[driver[0].driver_type][driver[0].country]).map((x, i) => {
                                return <option key={i} value={x}>{timeOffNames[driver[0].driver_type][driver[0].country][x]}</option>
                            })}
                        </CFormSelect>
                    </CCol>
                </CRow>
                <hr />
                <CRow>
                    <CCol sm={12} md={6}>
                        <CCardText className='fs-4'>Current Balance</CCardText>
                        <CCardText className='fs-1' style={{ fontWeight: '500' }}>{summary ? `${summary.balance} Days${type === 'TOVAC' && summary.statWorkedCount > 0 ? ` (Including ${summary.statWorkedCount} In Lieu) ` : ''}` : null}</CCardText>
                        <CTable borderless>
                            <CTableBody>
                                <CTableRow>
                                    <CTableDataCell className='fs-4'>Requested: </CTableDataCell>
                                    <CTableDataCell className='fs-4' style={{ textAlign: 'right' }}>{summary ? summary.requested : null}</CTableDataCell>
                                    <CTableDataCell className='fs-4'>Day(s)</CTableDataCell>
                                </CTableRow>
                                <CTableRow>
                                    <CTableDataCell className='fs-4' >Planned: </CTableDataCell>
                                    <CTableDataCell className='fs-4' style={{ textAlign: 'right' }}>{summary ? summary.planned : null}</CTableDataCell>
                                    <CTableDataCell className='fs-4' >Day(s)</CTableDataCell>
                                </CTableRow>
                                <CTableRow style={{ borderBottomWidth: '2px' }}>
                                    <CTableDataCell className='fs-4'>Used: </CTableDataCell>
                                    <CTableDataCell className='fs-4' style={{ textAlign: 'right' }}>{summary ? summary.used : null}</CTableDataCell>
                                    <CTableDataCell className='fs-4' >Day(s)</CTableDataCell>
                                </CTableRow>
                                <CTableRow>
                                    <CTableDataCell className='fs-4'>End of Year Balance: </CTableDataCell>
                                    <CTableDataCell className='fs-4' style={{ textAlign: 'right' }}>{summary ? summary.total : null}</CTableDataCell>
                                    <CTableDataCell className='fs-4' >Day(s)</CTableDataCell>
                                </CTableRow>
                            </CTableBody>
                        </CTable>
                    </CCol>
                    <CCol sm={12} md={6}>
                        <CCardTitle>{driver[0].mpp_firstname} {driver[0].mpp_lastname} {driver[0].trc_number ? ("(" + driver[0].trc_number + ")") : null}</CCardTitle>
                        <CCardBody>
                            <div className="bd-example">
                                <dl className="row">
                                    {driver[0].phone &&
                                        <>
                                            <dt className="col-sm-4">Phone</dt>
                                            <dd className="col-sm-8">{driver[0].phone}</dd>
                                        </>
                                    }
                                    {driver[0].email &&
                                        <>
                                            <dt className="col-sm-4">Email</dt>
                                            <dd className="col-sm-8">{driver[0].email}</dd>
                                        </>
                                    }
                                    {driver[0].status &&
                                        <>
                                            <dt className="col-sm-4">Status</dt>
                                            <dd className="col-sm-8">{driver[0].status}</dd>
                                        </>
                                    }
                                    {driver[0].terminal &&
                                        <>
                                            <dt className="col-sm-4">Terminal</dt>
                                            <dd className="col-sm-8">{driver[0].terminal}</dd>
                                        </>
                                    }
                                    {driver[0].hiredate &&
                                        <>
                                            <dt className="col-sm-4">Seniority Date</dt>
                                            <dd className="col-sm-8">{globalFunctions.formatDate(driver[0].hiredate)}</dd>
                                        </>
                                    }
                                    {driver[0].seniority &&
                                        <>
                                            <dt className="col-sm-4">Hire Date</dt>
                                            <dd className="col-sm-8">{globalFunctions.formatDate(driver[0].seniority)}</dd>
                                        </>
                                    }
                                </dl>
                            </div>
                        </CCardBody>

                    </CCol>
                </CRow>

            </CCardBody>
            {/* <CCardFooter className="text-medium-emphasis">2 days ago</CCardFooter> */}
        </CCard >)
}